// @flow

export default class EventObject {
  #name: string;
  #handler: EventListener;

  /**
   *
   */
  constructor(pName: string, pHandler: EventListener) {
    this.#name = pName;
    this.#handler = pHandler;
  }

  /**
   *
   */
  get name(): string {
    return this.#name;
  }

  /**
   *
   */
  get handler(): EventListener {
    return this.#handler;
  }
}
